"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpLink = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const link_html_1 = __importDefault(require("./link.html"));
const core_1 = require("@integro/core");
const log = (0, debug_1.default)('itp:ui:link');
let ItpLink = class ItpLink extends vue_1.default {
    url;
    isMouseOver;
    spinning;
    text;
    icon;
    href;
    tooltip;
    target;
    external;
    useAuth;
    noDownloadLink;
    forceDownload;
    noWrap;
    button;
    variant;
    to;
    disabled;
    downloadFileName;
    showSpinner;
    spinnerType;
    timeout;
    get className() {
        const result = {
            'itp-link': true,
            'btn btn-sm': this.button
        };
        if (this.button && this.variant) {
            _.set(result, 'border', this.variant === 'light');
            _.set(result, `btn-${this.variant}`, true);
        }
        return result;
    }
    get isDisabled() {
        return this.disabled;
    }
    get renderRouterLink() {
        return !!this.to;
    }
    get renderTextOrIcon() {
        return !this.renderRouterLink && (this.text || this.icon);
    }
    get renderDownload() {
        return !this.renderRouterLink && this.useAuth && !this.noDownloadLink;
    }
    data() {
        return {
            url: this.href ? core_1.downloads.normalizeLink(this.href) : '',
            isMouseOver: false,
            spinning: false
        };
    }
    onClick(ev) {
        if (this.forceDownload) {
            return this.onDownloadClick(ev);
        }
        if (this.useAuth) {
            ev.preventDefault();
            if (this.showSpinner) {
                this.spinning = true;
            }
            const options = this.timeout ? { timeout: this.timeout } : null;
            Promise.resolve(core_1.downloads.getFileBLOB(this.url, this.downloadFileName, options))
                .then(p => p && core_1.downloads.showFileInNewTab(p.file, p.fileName))
                .finally(() => (this.spinning = false));
            return;
        }
        if (!this.href) {
            ev.preventDefault();
            this.$emit('click', ev);
        }
    }
    onDownloadClick(ev) {
        if (this.useAuth) {
            ev.preventDefault();
            const options = this.timeout ? { timeout: this.timeout } : null;
            Promise.resolve(core_1.downloads.getFileBLOB(this.url, this.downloadFileName, options)).then(p => p && core_1.downloads.downloadFile(p.file, p.fileName));
        }
    }
};
exports.ItpLink = ItpLink;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpLink.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpLink.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpLink.prototype, "href", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpLink.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '_self' }),
    __metadata("design:type", String)
], ItpLink.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "external", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "useAuth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "noDownloadLink", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "forceDownload", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "noWrap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "button", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpLink.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], ItpLink.prototype, "to", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpLink.prototype, "downloadFileName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLink.prototype, "showSpinner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'grow' }),
    __metadata("design:type", String)
], ItpLink.prototype, "spinnerType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null }),
    __metadata("design:type", Number)
], ItpLink.prototype, "timeout", void 0);
exports.ItpLink = ItpLink = __decorate([
    (0, vue_property_decorator_1.Component)({ template: link_html_1.default })
], ItpLink);
//# sourceMappingURL=link.js.map